import localforage from 'localforage'
import * as rootTypes from '@/store/mutation-types'
import * as types from './mutation-types'

export default async store => {
  store.subscribe(mutation => {
    switch (mutation.type) {
      case rootTypes.SET_STORE:
        store.commit('menuModule/' + types.RESET_MENUS)
        break
      case 'menuModule/' + types.PUSH_MENU:
        if (mutation.payload.source === 'server') {
          const menuId = `stores/${store.getters.storeId}/menus/releases/${mutation.payload.menu.variation}/${mutation.payload.menu.version}`
          localforage.setItem(menuId, JSON.stringify(mutation.payload.menu))
        }
        break
      default:
    }
  })
}
